import { ConnectComponent } from '../../_components/ConnectComponent'
import { DateDurationView } from './DateDuration.view'
import { DateDurationPresenter } from './DateDuration.presenter'

export const DateDuration = ConnectComponent(
  DateDurationView,
  DateDurationPresenter,
)
